import { fetchPersea } from "@/config/axios/config-axios";
import { ConfirmUrlPostBody, GetUrlPost, SaveUrlPost, ValidateParticipantBody } from "./make-or-get-url-post-types";

const PATH = "social_media";

export const saveUrlTwitter = async (body: SaveUrlPost) => {
  const bodyParams = {
    ...body,
    twitter_link: body?.link,
    link: undefined
  }
  return await fetchPersea(`${PATH}/add-twitter`, 'POST', {}, bodyParams);
};

export const getUrlTwitter = async (params: GetUrlPost) => {
  const paramsParams = {
    ...params
  }
  return await fetchPersea(`${PATH}/add-twitter`, 'GET', paramsParams);
};

export const saveUrlFacebook = async (body: SaveUrlPost) => {
  const bodyParams = {
    ...body,
    facebook_link: body?.link,
    link: undefined
  }
  return await fetchPersea(`${PATH}/add-facebook`, 'POST', {}, bodyParams);
};

export const getUrlFacebook = async (params: GetUrlPost) => {
  const paramsParams = {
    ...params
  }
  return await fetchPersea(`${PATH}/add-facebook`, 'GET', paramsParams);
};

export const validateParticipation = async (body: ValidateParticipantBody) => {
  return await fetchPersea(`${PATH}/validate-participation`, 'POST', {}, body);
};

export const confirmUrlPost = async (body: ConfirmUrlPostBody) => {
  return await fetchPersea(`${PATH}/validate-participation/confirmation`, 'POST', {}, body);
};